import { render, staticRenderFns } from "./TextEl.vue?vue&type=template&id=612774cc&"
import script from "./TextEl.vue?vue&type=script&lang=ts&"
export * from "./TextEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports